const PASSWORD_KEY = 'lite_abcdefghijklmn';
export function xorEncryptDecrypt(str) {
  let result = '';
  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i) ^ PASSWORD_KEY.charCodeAt(i % PASSWORD_KEY.length);
    result += String.fromCharCode(charCode);
  }
  return result;
}
